<div class="sales-order-confirmation-dialog">
  <h2 mat-dialog-title>
    <mat-icon color="warn" class="pt-2">warning</mat-icon>
    Delete Sales Orders
  </h2>

  <p>
    Are you sure you want to delete the selected sales orders? This action cannot be
    undone.
  </p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-checkbox
      color="primary"
      (change)="onRollBackInvetoryChange($event)"
      formControlName="isRollbackInventory"
    >
      Rollback inventory changes for orders?
    </mat-checkbox>

    <div *ngIf="loading; else orderItems" class="flex justify-content-center">
      <mat-spinner color="primary" diameter="20"></mat-spinner>
    </div>

    <ng-template #orderItems>
      <div *ngIf="form?.get('isRollbackInventory')?.value" class="mt-4">
        <ng-container
          *ngIf="
            form?.get('items')?.controls?.length && hasShippedOrders;
            else noData
          "
        >
          <h6>Order Items</h6>
          <ag-grid-angular
            #agGrid
            style="width: 100%; height: 400px"
            class="ag-theme-alpine"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [pagination]="true"
            [paginationPageSize]="paginationPageSize"
            (gridReady)="onGridReady($event)"
            (paginationChanged)="onPageChange($event)"
          >
          </ag-grid-angular>
        </ng-container>

        <ng-template #noData>
          <lum-ui-empty-page
            class="mt-4"
            title="No Order Items"
          ></lum-ui-empty-page>
        </ng-template>
      </div>
    </ng-template>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-button type="submit" color="warn" [disabled]="submitting">
        <mat-icon>delete</mat-icon>
        {{ isRollbackInventory ? 'Delete & Rollback' : 'Delete' }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
